// extracted by mini-css-extract-plugin
module.exports = {"main-orange":"#ec7910","example":"styles-module__example___3oEZQ","icon":"styles-module__icon___1_e2z"};